import { useTranslation } from "react-i18next";
import { connectModal } from "redux-modal";
import BMXCardModal from "../../../../Components/Modals/BMXCardModal/BMXCardModal";
import EditServicePartForm from "../../Forms/ServiceForms/ServicePartForm/EditServicePartForm/EditServicePartForm";
import EditServiceValuationServiceForm from "../../Forms/ServiceForms/ServiceValuationForm/EditServiceValuationServiceForm/EditServiceValuationServiceForm";

const EditServiceValuationServiceModal = (props) => {
    const { handleHide, show, header } = props;
    const { t } = useTranslation();

    return (
        <BMXCardModal
            width="350px"
            height="max-content"
            header={header || t("global:editServiceValuationServiceModal.header")}
            open={show}
            onClose={handleHide}
            onOutside={false}
        >
            <EditServiceValuationServiceForm {...props} />

        </BMXCardModal>
    );
};

export default connectModal({ name: "editServiceValuationServiceModal" })(EditServiceValuationServiceModal);